import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="idea-form"
export default class extends Controller {
  static targets = ["name", "prompt", "topic"]

  addPrompt(event) {
    event.preventDefault()
    const prompt = event.target.dataset.prompt
    this.topicTarget.value += "\n" + prompt
  }
}
